module.exports = __webpack_public_path__ + "static/media/react.f297dfcd.png";